/** Browsers tell us directly, which lets us flush the outbox the moment we reconnect. */
export function isProbablyOnline(): boolean {
  try {
    return typeof navigator === 'undefined' || navigator.onLine !== false;
  } catch {
    return true;
  }
}

export function onNetworkChange(cb: (online: boolean) => void): () => void {
  if (typeof window === 'undefined') return () => {};
  const up = () => cb(true);
  const down = () => cb(false);
  window.addEventListener('online', up);
  window.addEventListener('offline', down);
  return () => {
    window.removeEventListener('online', up);
    window.removeEventListener('offline', down);
  };
}
